<template>
    <div>
      <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
      <v-data-table
        :headers="headers"
        :items="ciData"
        :loading="loading"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :page.sync="page"
        item-key="id"
        hide-default-footer
        hide-default-header
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>CI - Lists</v-toolbar-title>
  
            <v-divider class="mx-4" inset vertical></v-divider>
            <export-list :ciData="ciData" />
            <v-spacer></v-spacer>
            <v-btn
              @click="viewCreateForm"
              color="teal accent-4"
              depressed
              dark
              class="mb-1"
            >
              <v-icon left dark> mdi-plus-circle-outline </v-icon>
              New Item
            </v-btn>
          </v-toolbar>
        </template>
  
        <template v-slot:header="{ props: { headers } }">
          <thead class="header">
            <tr>
              <th
                v-for="header in headers"
                :key="header.text"
                class="header--text"
              >
                {{ header.text }}
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:item="{ index, item }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ item.presumptive?item.presumptive.name:'' }}</td>
            <!-- <td>{{ item.patient.mdrtb_reg_no?item.patient.mdrtb_reg_no:'' }}</td>
            <td>{{ item.patient.mdrtb_reg_year?item.patient.mdrtb_reg_year:'' }}</td> -->
            <td>{{ item.patient && item.patient.mdrtb_reg_no ? item.patient.mdrtb_reg_no : '' }}</td>
            <td>{{ item.patient && item.patient.mdrtb_reg_year ? item.patient.mdrtb_reg_year : '' }}</td>
            <td>{{ item.township? item.township.name:''}}</td>
            <td>{{ item.screening_township? item.screening_township.name:''}}</td>
            <td>{{ item.screening_person=='1'? 'Volunteer' : 'FO'}}</td>
            <td>{{ item.symptom_screening=='1'? 'No' : 'Yes'}}</td>
            <td>{{ item.refer=='1'? 'No' : 'Yes'}}</td>
            <td>{{ item.date }}</td>
            <td>
              <div class="mr-2 d-flex inline">
                <v-btn
                  @click="goUpdateForm(item)"
                  icon
                  color="orange darken-1"
                  class="mr-2 white--text"
                  depressed
                >
                  <v-icon> mdi-pencil-outline </v-icon>
                </v-btn>
                <v-btn
                  @click="openConfrimBox(item)"
                  icon
                  color="red lighten-1"
                  class="white--text"
                  depressed 
                >
                  <v-icon> mdi-delete-outline </v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center py-3">
        <v-pagination
          color="purple accent-4"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import ConfirmBox from "@/components/notification/ConfirmBox";

  export default {
    props: {
      ciData: {
        type: Array,
      },
    },
    components: {
      ConfirmBox
    },
    data: () => ({
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      townshipId: null,
      item: {},
      dialog: false,
      headers: [
        { text: "No", value: "no" },
        { text: "Name", value: "name" }, 
        { text: "Code", value: "mdrtb_reg_no" }, 
        { text: "Year", value: "mdrtb_reg_year" }, 
        { text: "Screening Township", value: "township" }, 
        { text: "Cross Township", value: "screening_township" }, 
        { text: "Screening Person", value: "screening_person" },
        { text: "Symptom Screening", value: "symptom_screening" },
        { text: "Refer", value: "refer" },
        { text: "Date", value: "date" },
        { text: "Action", value: "action" },
      ],
    }),
    computed: {
      ...mapState("Loading", ["loading"]),
    },
    methods: {
      viewCreateForm() {
        this.$router.push({
          name: "create-ci",
          params: {
            month: this.$route.params.month,
            year: this.$route.params.year,
            township_id:this.$route.params.township_id
          },
        });
      },
      openConfrimBox(item) {
        this.item = item;
        this.dialog = !this.dialog;
      },
      deletePatient() {
        let data = {
          id: this.item.id,
        };
        this.$store
          .dispatch("Ci/delete", data)
          .then(() => (this.dialog = !this.dialog));
      },
      cancel() {
        this.dialog = !this.dialog;
      },
      goUpdateForm(item) {
        let convertNumber = parseInt(item.id);
        this.$router.push({
          name: "edit-ci",
          params: {
            id: convertNumber,
            month: this.$route.params.month,
            year: this.$route.params.year,
            township_id:this.$route.params.township_id,
          },
        });
      },
    },
  };
  </script>
  
  <style scoped></style>
  